import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22003a0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-6 mb-xl-9 position-relative" }
const _hoisted_2 = {
  key: 0,
  class: "card-header"
}
const _hoisted_3 = { class: "row justify-content-between col-md-12 ml-0 mr-0 d-flex align-items-md-center text-center pt-3 pb-5 align-self-center align-center" }
const _hoisted_4 = { class: "text-gray-800" }
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = {
  key: 1,
  class: "fas fa-power-off fa-2x text-danger"
}
const _hoisted_8 = { class: "col-md-3 p-6" }
const _hoisted_9 = { class: "text-gray-800" }
const _hoisted_10 = { style: {"font-family":"monospace"} }
const _hoisted_11 = { class: "col-md-3 p-6" }
const _hoisted_12 = { class: "d-flex align-self-center" }
const _hoisted_13 = { class: "text-gray-800" }
const _hoisted_14 = { class: "row d-flex align-items-center justify-content-center" }
const _hoisted_15 = { class: "col-md-10" }
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-primary svg-icon-2x" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M3,13.5 L19,12 L3,10.5 L3,3.7732928 C3,3.70255344 3.01501031,3.63261921 3.04403925,3.56811047 C3.15735832,3.3162903 3.45336217,3.20401298 3.70518234,3.31733205 L21.9867539,11.5440392 C22.098181,11.5941815 22.1873901,11.6833905 22.2375323,11.7948177 C22.3508514,12.0466378 22.2385741,12.3426417 21.9867539,12.4559608 L3.70518234,20.6826679 C3.64067359,20.7116969 3.57073936,20.7267072 3.5,20.7267072 C3.22385763,20.7267072 3,20.5028496 3,20.2267072 L3,13.5 Z",
        fill: "#4caf50"
      })
    ])
  ])
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "col-md-3 p-6" }
const _hoisted_20 = { class: "text-gray-800" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-stopwatch fa-2x" }, null, -1))
const _hoisted_22 = ["title"]
const _hoisted_23 = ["title"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-primary svg-icon-2x" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        fill: "#4caf50",
        x: "4",
        y: "11",
        width: "16",
        height: "2",
        rx: "1"
      }),
      /*#__PURE__*/_createElementVNode("rect", {
        fill: "#4caf50",
        transform: "translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) ",
        x: "4",
        y: "11",
        width: "16",
        height: "2",
        rx: "1"
      })
    ])
  ])
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_27 = { class: "card-body pt-9 pb-0" }
const _hoisted_28 = { class: "d-flex flex-wrap flex-sm-nowrap mb-6 mr-2" }
const _hoisted_29 = {
  key: 0,
  class: "symbol w-200px bg-light border border-success"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-shrink-0 bg-light rounded w-100 h-100 me-7 mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mw-50px mw-lg-75px floating",
    src: "/media/logos/machines/challs.png",
    alt: "image"
  })
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "symbol w-200px bg-light border border-info"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-shrink-0 bg-light rounded w-100 h-100 me-7 mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mw-50px mw-lg-75px floating",
    src: "/media/logos/machines/challs.png",
    alt: "image"
  })
], -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 2,
  class: "symbol w-200px bg-light border border-warning"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-shrink-0 bg-light rounded w-100 h-100 me-7 mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mw-50px mw-lg-75px floating",
    src: "/media/logos/machines/challs.png",
    alt: "image"
  })
], -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 3,
  class: "symbol w-200px bg-light border border-danger"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-shrink-0 bg-light rounded w-100 h-100 me-7 mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mw-50px mw-lg-150px floating",
    src: "/media/logos/machines/challs.png",
    alt: "image"
  })
], -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  class: "flex-grow-1",
  style: {"margin-left":"20px"}
}
const _hoisted_42 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_43 = { class: "d-flex flex-column" }
const _hoisted_44 = { class: "d-flex align-items-center mb-1" }
const _hoisted_45 = { class: "text-gray-800 fs-2 fw-bolder me-3" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_47 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_48 = {
  key: 1,
  class: "badge badge-light-info"
}
const _hoisted_49 = {
  key: 2,
  class: "badge badge-light-warning"
}
const _hoisted_50 = {
  key: 3,
  class: "badge badge-light-danger"
}
const _hoisted_51 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_52 = {
  key: 4,
  class: "badge badge-light-primary me-3"
}
const _hoisted_53 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_54 = {
  key: 5,
  class: "badge badge-light-success"
}
const _hoisted_55 = {
  key: 0,
  class: "d-flex flex-wrap fw-bold mb-2 fs-5 text-gray-500"
}
const _hoisted_56 = { class: "d-flex col-md-5" }
const _hoisted_57 = { class: "col-md-10 p-6" }
const _hoisted_58 = {
  key: 0,
  class: "text-gray-800"
}
const _hoisted_59 = ["title"]
const _hoisted_60 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_61 = { class: "d-flex" }
const _hoisted_62 = {
  key: 1,
  class: "d-flex col gap-4 justify-content-end"
}
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_65 = { class: "sr-only" }
const _hoisted_66 = {
  key: 1,
  class: "fas fa-play fa-1x"
}
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { class: "d-flex flex-wrap justify-content-start" }
const _hoisted_69 = { class: "d-flex flex-wrap" }
const _hoisted_70 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_71 = { class: "fw-bold fs-6 text-gray-500 mb-4" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock-history text-success" }, null, -1))
const _hoisted_73 = { class: "d-flex align-items-center" }
const _hoisted_74 = { class: "fs-4 fw-bolder" }
const _hoisted_75 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_76 = { class: "fw-bold fs-6 text-gray-500 mb-4" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-stars text-info" }, null, -1))
const _hoisted_78 = { class: "d-flex align-items-center" }
const _hoisted_79 = {
  class: "symbol symbol-25px symbol-circle",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": ""
}
const _hoisted_80 = ["src", "title"]
const _hoisted_81 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_82 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-500 mb-4" }, [
  /*#__PURE__*/_createTextVNode(" First Blood "),
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-droplet text-danger" })
], -1))
const _hoisted_84 = { class: "d-flex align-items-center" }
const _hoisted_85 = {
  class: "symbol symbol-25px symbol-circle",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": ""
}
const _hoisted_86 = ["src", "title"]
const _hoisted_87 = {
  key: 1,
  alt: "Pic",
  src: "/media/avatars/blank.png"
}
const _hoisted_88 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_89 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_90 = {
  class: "fw-bold fs-6 text-gray-500 mb-4",
  title: "Total experience you will earn on completion"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gem text-warning" }, null, -1))
const _hoisted_92 = { class: "d-flex align-items-center" }
const _hoisted_93 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_94 = {
  class: "fs-5 fw-bolder counted",
  "data-kt-countup": "true",
  "data-kt-countup-value": "",
  "data-kt-countup-prefix": "$"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-gray-400" }, "xp", -1))

import {ref, onMounted} from "vue";
import { useStore } from "vuex";
import {hasFeature} from "@/core/helpers/feature";
import {computed} from "vue";
import { useI18n } from 'vue-i18n'
import moment from "moment/moment";
import ApiService from "@/core/services/ApiService";
import {Actions, Mutations} from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import router from "@/router";
import posthog from "posthog-js";

export default /*#__PURE__*/_defineComponent({
  props: {
  challenge: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: "training",
  },
},
  setup(__props) {

const props = __props

const { t } = useI18n()

const store = useStore();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));

const release_countdown =  ref("")
const release_countdown_started = ref(false)
const countdown =  ref("")
const countdown_started = ref(false)
const loading =  ref(false)
const flag_input = ref("")



onMounted(()=>{
  if (!countdown_started.value) {
    if (props.challenge.instance) {
      setInterval(update, 1000);
      countdown_started.value = true;
    }
  }

  if (!release_countdown_started.value) {
    if (props.challenge) {
      setInterval(update_release_countdown, 1000);
      release_countdown_started.value = true;
    }
  }
})

const update_release_countdown = () => {
  if (props.challenge.release_at) {
    const now = moment.utc();
    const end = moment.utc(props.challenge.release_at);
    const duration = moment.duration(end.diff(now));
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    const days = duration.days();

    if(days <=0 &&hours <= 0 && minutes <= 0 && seconds <= 0){
      release_countdown.value = '';
    }else{
      release_countdown.value = `${days}d ${hours}h ${minutes}m ${seconds}s`;
    }

  }
}

const update = (challenge) => {
  const now = moment.utc();
  const end = challenge ? moment.utc(challenge.instance.shutdown) : moment.utc(props.challenge.instance.shutdown);

  const duration = moment.duration(end.diff(now));
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();


  if(hours <= 0 && minutes <= 1 && seconds == 59){
    // play alert sound
    play_alert_sound();
  }

  if(hours <= 0 && minutes <= 0 && seconds == 20){
    // play alert sound
    play_alert_sound();
  }
  if(hours <= 0 && minutes <= 0 && seconds <= 0){
    countdown.value = '';

  }else{
    countdown.value = `${hours}h ${minutes}m ${seconds}s`;
  }
}

const play_alert_sound = () => {
  const audio = new Audio('/media/alert.mp3');
  audio.play();
};

const StopInstance = ()=>{
  if(loading.value){
    return;
  }

  loading.value = true;
  ApiService.get("labs/challenges/" + props.challenge.id + "/stop")
      .then(({ data }) => {

        if(data.success){
          store.commit(Mutations.SET_CHALLENGES, data.challenge);
          // atualiza o indicador de instância ligada no topo
          store.dispatch(Actions.VERIFY_AUTH);
          loading.value = false;
        }else{
          Swal.fire({
            title: "Oops...",
            text: data.message,
            icon: "error",
            confirmButtonText: "Ok",
          });
          store.commit(Mutations.SET_CURRENT_MACHINE, data.machine);
          loading.value = false;
        }

      }).catch(error => {
        Swal.fire({
          title: "Oops...",
          text: t(`${currentLanguage.value}.messages.we_had_a_problem_closing_your_instance_contact_support`),
          icon: "error",
          confirmButtonText: "Ok",
        });
        loading.value = false;
      });
}

const StartInstance = ()=>{

  if(loading.value){
    return;
  }
  loading.value = true;
  ApiService.get("labs/challenges/" + props.challenge.id + "/start")
      .then(({ data }) => {

        if(data.success){
          store.commit(Mutations.SET_CHALLENGES, data.challenge);
          // atualiza o indicador de instância ligada no topo
          store.dispatch(Actions.VERIFY_AUTH);
          posthog.capture('started_challenge_instance', {
            id: props.challenge.id,
            name: data.challenge.name,
            difficulty: data.challenge.difficulty,
            points: data.challenge.points,
            is_freemium: data.challenge.is_freemium
          });
          loading.value = false;
          countdown_started.value = true;
          setInterval(()=>{
            if(props.challenge.instance){
              update(props.challenge);
            }else{
              update(data.challenge);
            }
          }, 1000);

        }else{
          Swal.fire({
            title: "Oops...",
            text: data.message,
            icon: "error",
            confirmButtonText: "Ok",
          });
          loading.value = false;
        }

      }).catch(error => {
        if(error.response?.data?.message){
          Swal.fire({
            title: "Oops...",
            text: error.response.data.message,
            icon: "warning",
            confirmButtonText: "Ok",
          });
        }else{
          console.error(error)
          Swal.fire({
            title: "Oops...",
            text: t(`${currentLanguage.value}.messages.we_had_a_problem_starting_your_instance_please_try_again_later`),
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
        loading.value = false;
      });
}

const submitFlag = ()=>{

  if(!flag_input.value){
    Swal.fire({
      title: "Oops...",
      text: t(`${currentLanguage.value}.messages.please_insert_a_flag`),
      icon: "error",
      confirmButtonText: "Ok",
    });
    return;
  }
  ApiService.vueInstance.axios.put("/labs/challenges/pown/"+props.challenge.id, {
    flag: flag_input.value
  }).then(async ({ data }) => {
    if(data.success){
      const alreadySent = !!(data.message.toLowerCase().includes('já enviou') || data.message.toLowerCase().includes('already sent'))
      if (alreadySent) {
        Swal.fire({
          title: t(`${currentLanguage.value}.messages.flag_already_sent`),
          text: data.message,
          icon: "info",
          confirmButtonText: "Ok",
        });
      } else {
        await Swal.fire({
          title: t(`${currentLanguage.value}.messages.congratulations`),
          text: data.message,
          icon: "success",
          confirmButtonText: "Ok",
        });
      }
      store.dispatch(Actions.GET_CHALLENGE, props.challenge.id);
    }else{
      Swal.fire({
        title: "Oops...",
        text: data.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  }).catch(error => {

    Swal.fire({
      title: "Oops...",
      text: t(`${currentLanguage.value}.messages.we_had_a_problem_verifying_your_flag_please_try_again`),
      icon: "error",
      confirmButtonText: "Ok",
    });
  });
}

const addTime = ()=>{
  if(loading.value){
    return;
  }
  loading.value = true;
  ApiService.get("labs/challenges/" + props.challenge.id + "/addTime")
      .then(({ data }) => {

        if(data.success){
          store.commit(Mutations.SET_CHALLENGES, data.challenge);
          // atualiza o indicador de instância ligada no topo
          store.dispatch(Actions.VERIFY_AUTH);
          update(data.challenge);
          Swal.fire({
            title: t(`${currentLanguage.value}.messages.congratulations`),
            text: data.message || t(`${currentLanguage.value}.messages.you_ve_added_more_time_to_your_instance`),
            icon: "success",
            confirmButtonText: "Ok",
          });
        }else{
          Swal.fire({
            title: "Oops...",
            text: data.message,
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
        loading.value = false;
      }).catch(error => {
        Swal.fire({
          title: "Oops...",
          text: t(`${currentLanguage.value}.messages.we_had_a_problem_adding_time_to_your_instance_please_try_again_later`),
          icon: "error",
          confirmButtonText: "Ok",
        });
        loading.value = false;
      });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.challenge.instance && __props.challenge.instance.is_active)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "machine-card-top-btn cursor-pointer col-md-3 p-6",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (StopInstance()))
              }, [
                _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.challenge.shutdown_instance`)), 1),
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.loading`)) + "...", 1)
                    ]))
                  : (_openBlock(), _createElementBlock("i", _hoisted_7))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.ip_address`)), 1),
                _createElementVNode("p", _hoisted_10, _toDisplayString(__props.challenge.instance.ip_address), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.send`)) + " flag", 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "flag",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((flag_input).value = $event)),
                      placeholder: "hackingclub{FLAG}"
                    }, null, 512), [
                      [_vModelText, flag_input.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("i", {
                      class: "cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (submitFlag()))
                    }, _hoisted_18)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.challenge.time_remaining`)), 1),
                _hoisted_21,
                _createElementVNode("b", {
                  title: _ctx.$t(`${_unref(currentLanguage)}.challenge.time_remaining_machine`)
                }, " " + _toDisplayString(countdown.value || "00:00:00h"), 9, _hoisted_22),
                _createElementVNode("i", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (addTime())),
                  class: "cursor-pointer",
                  title: _ctx.$t(`${_unref(currentLanguage)}.challenge.add_another_1h`)
                }, _hoisted_25, 8, _hoisted_23)
              ])
            ]),
            _hoisted_26
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          (__props.challenge.difficulty == 'easy')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
            : _createCommentVNode("", true),
          (__props.challenge.difficulty == 'medium')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
            : _createCommentVNode("", true),
          (__props.challenge.difficulty == 'hard')
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
            : _createCommentVNode("", true),
          (__props.challenge.difficulty == 'insane')
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("a", _hoisted_45, _toDisplayString(__props.challenge.name), 1),
                  _hoisted_46,
                  (__props.challenge.difficulty == 'easy')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.easy`)), 1))
                    : _createCommentVNode("", true),
                  (__props.challenge.difficulty == 'medium')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.medium`)), 1))
                    : _createCommentVNode("", true),
                  (__props.challenge.difficulty == 'hard')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.hard`)), 1))
                    : _createCommentVNode("", true),
                  (__props.challenge.difficulty == 'insane')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.insane`)), 1))
                    : _createCommentVNode("", true),
                  _hoisted_51,
                  (__props.type == 'training')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, "training"))
                    : _createCommentVNode("", true),
                  _hoisted_53,
                  (__props.challenge.is_freemium)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_54, "Free"))
                    : _createCommentVNode("", true)
                ]),
                (__props.type == 'training')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(__props.challenge.description || ""), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  (release_countdown.value)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_58, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.challenge.release_in`)) + "  " + _toDisplayString(release_countdown.value || "00:00:00"), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: "col-md-1 icon-position",
                  title: !_unref(hasFeature)('challenge_access') && !__props.challenge.is_freemium ? _ctx.$t(`${_unref(currentLanguage)}.challenge.only_subscribers_can_start_this_machine`): _ctx.$t(`${_unref(currentLanguage)}.challenge.start_an_instance`)
                }, [
                  (!_unref(hasFeature)('challenge_access') && !__props.challenge.is_freemium)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_component_router_link, {
                            to: {name: 'profile-billing'},
                            class: _normalizeClass([_unref(currentLanguage) == 'pt' ? 'px-6' : _unref(currentLanguage) == 'es' ? 'px-5' : 'px-4', "menu-title bg-success py-3 rounded text-white bg-hover-opacity-75"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.subscribe`)), 1)
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        ((!__props.challenge.instance || __props.challenge.instance.is_active == false)  )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (StartInstance())),
                              class: _normalizeClass(!_unref(hasFeature)('challenge_access') && !__props.challenge.is_freemium ? 'btn btn-light-success disabled': 'btn btn-light-success'),
                              disabled: !_unref(hasFeature)('challenge_access') && !__props.challenge.is_freemium ? 'disabled': 'false',
                              id: "start_instance_btn"
                            }, [
                              (loading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                    _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.loading`)) + "...", 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_66))
                            ], 10, _hoisted_63))
                          : _createCommentVNode("", true)
                      ]))
                ], 8, _hoisted_59)
              ])
            ]),
            (__props.type == 'training')
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.challenge.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: tag,
                      class: "badge badge-light-dark me-3 mb-3"
                    }, _toDisplayString(tag), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.release_date`)) + " ", 1),
                    _hoisted_72
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, _toDisplayString(_unref(moment)
                            .utc(__props.challenge.release_at)
                            .format("DD MMMM, YYYY")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.creator`)) + " ", 1),
                    _hoisted_77
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      (__props.challenge.creator)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            alt: "Pic",
                            src: 
                          __props.challenge.creator.avatar || '/media/avatars/blank.png'
                        ,
                            title: __props.challenge?.creator?.nick || 'No nick'
                          }, null, 8, _hoisted_80))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_81,
                    _createVNode(_component_router_link, {
                      to: {name: 'profile-user', params: {id: __props.challenge?.creator?.id}},
                      class: "fs-5 fw-bolder counted",
                      "data-kt-countup": "true",
                      "data-kt-countup-value": "15000",
                      "data-kt-countup-prefix": "$"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.challenge.creator?.nick || 'No nick'), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_82, [
                  _hoisted_83,
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      (__props.challenge.first_blood)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            alt: "Pic",
                            src: 
                          __props.challenge.first_blood.avatar ||
                          '/media/avatars/blank.png'
                        ,
                            title: __props.challenge?.first_blood?.nick ? __props.challenge?.first_blood?.nick : 'no blood'
                          }, null, 8, _hoisted_86))
                        : (_openBlock(), _createElementBlock("img", _hoisted_87))
                    ]),
                    _hoisted_88,
                    (__props.challenge.first_blood)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: { name: 'profile-user', params: { id: __props.challenge?.first_blood?.id } },
                          class: "fs-5 fw-bolder counted",
                          "data-kt-countup": "true",
                          "data-kt-countup-value": "15000",
                          "data-kt-countup-prefix": "$"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.challenge.first_blood.nick || "no blood"), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createTextVNode(" Total " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.of`)) + " XP ", 1),
                    _hoisted_91
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _hoisted_93,
                    _createElementVNode("div", _hoisted_94, [
                      _createTextVNode(_toDisplayString(__props.challenge.points) + " ", 1),
                      _hoisted_95
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})